import { createIcon } from '../create-icon'

export const GamingHeadset = createIcon('GamingHeadset', ({ strokeWidth }) => (
  <>
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" strokeWidth={strokeWidth} />
    <path
      d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3v5Z"
      strokeWidth={strokeWidth}
    />
    <path
      d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3v5Z"
      strokeWidth={strokeWidth}
    />
    <path d="M19 21v1a2 2 0 0 1-2 2h-4" strokeWidth={strokeWidth} />
  </>
))
